const titlesByPath = {
  '/dashboard': 'Сводная аналитика',
  '/offers': 'Управление офферами',
  '/customers': 'Управление пользователями',
  '/payouts': 'Выплаты',
  '/orders': 'Выплаты',
  '/settings': 'Настройки системы'
};

function Header({ currentPath, currentUser, onLogoutSuccess }) {
  const title = titlesByPath[currentPath] || 'Админ-панель';

  const handleLogout = async () => {
    try {
      await fetch('/api/admin/auth/logout', {
        method: 'POST',
        credentials: 'include'
      });
    } finally {
      onLogoutSuccess();
    }
  };

  return (
    <header className="top-header">
      <div>
        <p className="header-kicker">Администрирование TopTopAff</p>
        <h2>{title}</h2>
        <p className="header-user">{currentUser?.email || 'администратор'}</p>
      </div>

      <div className="header-controls">
        <button type="button" className="accent-button" onClick={handleLogout}>
          Выйти
        </button>
      </div>
    </header>
  );
}

export default Header;